// This class is used for requesting IDs.

export class IDUtil {

    //set during login
    static idService: any;
    static ids: number[] = [];

    static ID_REQUEST_COUNT: number = 50; //number of IDs in each request to back end
    static ID_LOW_THRESHOLD: number = 20; //will request more IDs if below this threshold

    //need to inject the service at login or in main module (after refresh)
    static setService(service) {
        this.idService = service;
    }

    //Request additional IDs from backend
    static requestIDs() {
        if(this.idService)
        {
            this.idService.getIDsFromServer(IDUtil.ID_REQUEST_COUNT)
                .subscribe((res: number[]) => {
                    this.ids = this.ids.concat(res);
            });
        }

    }

    //Return a ID for use by UI objects.
    static getID(): string {
        //remove first ID from array to return
        let id: number = this.ids.shift();

        //get more IDS if below threshold
        if (this.ids.length < IDUtil.ID_LOW_THRESHOLD) {
            IDUtil.requestIDs();
        }
        return String(id);
    }

}
